import { post_add_trace_orders } from "services/Middleware"

const UseShippingGroupTraces = () => {
  const postAddTraceShippingGroup = async (orderId: string, body: any) => {
    const res = await post_add_trace_orders(orderId, body)
    return res
  }

  return {
    postAddTraceShippingGroup,
  }
}

export default UseShippingGroupTraces
